import { render, staticRenderFns } from "./PendingApplicationsView.vue?vue&type=template&id=2ead558d&scoped=true&"
import script from "./PendingApplicationsView.vue?vue&type=script&lang=js&"
export * from "./PendingApplicationsView.vue?vue&type=script&lang=js&"
import style0 from "./PendingApplicationsView.vue?vue&type=style&index=0&id=2ead558d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead558d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
